function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { withTheme } from 'styled-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Loading } from '@finect/tabular-components/Loading';
import { Head } from '@finect/tabular-components/Head';
import { Container } from '@finect/tabular-core/Container';
import { ContainerInner } from '@finect/tabular-core/ContainerInner';
import { MainContent } from '@finect/tabular-core/MainContent';
import { NotFound } from '@finect/tabular-components/NotFound';
import { DatalayerScene } from '@finect/front-gtm';
import { Redirect } from '@finect/front-core/Routes';
import { CategoryKPIs, CategoryFundsColumnsComparison, CategoryManagementCompanies, CategoryDescription, CategoryFunds, CategoryHeader } from '@finect/tabular-components/Modules';
import { isPreRelease } from '@finect/front-utils/isPreRelease';
import { withSubscriptions } from '@finect/front-core/User';
import { getProductTypeBySlug, getFundsCategoryPath } from '@finect/front-resources/Products';
import { isNode } from '@finect/front-utils/isNode';
import { clearCategory } from '../commons/store/fund/actions';
import { FamilyInsideNavigation } from '../commons/IIC/components';
import { fetchIICCategoryInitialData } from '../commons/IIC/actions/thunks';
import { getCategoryPath } from '../commons/IIC/utils/paths';
import { DistributionChart } from './components';
const mapStateToProps = state => ({
  category: state.fund.category,
  fundsByCategory: state.fund.fundsByCategory,
  subscriptions: state.user.subscriptions.products
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchIICCategoryInitialData,
    clearCategory
  }, dispatch)
});
class Category extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "handleFollow", (product, follow) => {
      const {
        handleEntityFollow
      } = this.props;
      handleEntityFollow('product', 'subscribe', product, follow);
    });
  }
  static loadInitialData(store, cookies, match) {
    const productType = getProductTypeBySlug(match.params.typeSlug);
    return store.dispatch(fetchIICCategoryInitialData({
      productType,
      category: match.params.id
    }));
  }
  componentDidMount() {
    const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
    if (this.props.match.params.id && !this.props.category.fetched) {
      this.props.actions.fetchIICCategoryInitialData({
        productType,
        category: this.props.match.params.id
      });
    }
  }
  componentWillUnmount() {
    this.props.actions.clearCategory();
  }
  render() {
    const {
      theme
    } = this.props;
    const {
      model: category,
      fetching,
      fetched
    } = this.props.category;
    const {
      typeSlug
    } = this.props.match.params;
    const productType = getProductTypeBySlug(typeSlug);
    if (fetched && !fetching && !category) {
      return React.createElement(NotFound, this.props);
    }
    if (fetching) {
      return React.createElement(Container, null, React.createElement(ContainerInner, null, React.createElement(MainContent, {
        fullWidth: true
      }, React.createElement(Loading, null))));
    }
    if (!category) {
      return React.createElement(NotFound, this.props);
    }
    if (isNode() && this.props.match.params.alias !== category.alias) {
      return React.createElement(Redirect, _extends({}, this.props, {
        status: 301,
        to: getCategoryPath(productType, category)
      }));
    }
    return React.createElement(React.Fragment, null, React.createElement(Head, {
      title: `${category.name} - Categoría de ${productType.plural}`,
      description: `${productType.plural} de la categoría ${category.name}`,
      canonical: getFundsCategoryPath(theme, productType, category)
    }), React.createElement(DatalayerScene, {
      pageType: "category",
      pageId: category.id
    }), React.createElement(Container, null, React.createElement(FamilyInsideNavigation, {
      productType: productType,
      current: "category"
    })), React.createElement(Container, null, React.createElement(ContainerInner, null, React.createElement(MainContent, {
      style: {
        maxWidth: '100%'
      },
      fullWidth: true
    }, React.createElement(CategoryHeader, {
      category: category
    }), React.createElement(CategoryDescription, {
      category: category
    }), isPreRelease ? React.createElement(DistributionChart, {
      timePeriod: "M36",
      category: category.id,
      data: []
    }) : null, React.createElement(CategoryKPIs, {
      category: category,
      productType: productType
    }), React.createElement(CategoryFundsColumnsComparison, {
      category: category,
      productType: productType
    }), React.createElement(CategoryFunds, {
      category: category,
      funds: this.props.fundsByCategory,
      productType: productType,
      subscriptions: this.props.subscriptions,
      onFollow: this.handleFollow
    }), React.createElement(CategoryManagementCompanies, {
      productType: productType,
      category: category
    })))));
  }
}
export default withSubscriptions(withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(Category))), ['products']);